// extracted by mini-css-extract-plugin
export var button = "_kp-0";
export var donut = "_kp-1";
export var donutFill = "_kp-3";
export var donutTrack = "_kp-2";